import { forSelect } from '../graphQL/queries/carrierRelationship';

export const retrieveCarrierFilterData = async (orgId, ApolloClient) => {
  const {
    data: {
      carrier: { all }
    }
  } = await ApolloClient.query({
    query: forSelect,
    variables: { orgId }
  });
  return all;
};
